import Popup from '../../plugins/Popup';

$(function () {
  var page = {};
  page.specs = $('.used-page__specs');
  page.gallery = $('.used-page__ingal');
  page.slider = {};
  page.slider.container = $('.dc-slider');
  page.slider.items = page.slider.container.find('.dc-slider__item');
  page.slider.slideTimeout = null;

  const getSpeed = (itemIndex = false) => {
    var total, id;
    if (itemIndex === false) id = page.slider.items.eq(0).data('car');
    else id = page.slider.items.eq(itemIndex).data('car');

    total = page.slider.items.filter(function (index) {
      return page.slider.items.eq(index).data('car') === id;
    }).length;

    return page.settings.carSlideDuration / total;
  };

  page.settings = {};
  page.settings.slidePerCar = 3;
  page.settings.carSlideDuration = 10000;
  page.settings.tickDuration = page.settings.carSlideDuration / page.settings.slidePerCar;
  page.settings.queue = window.queue.split(',');
  page.settings.slider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    arrows: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    autoplay: true,
    autoplaySpeed: getSpeed(),
  };

  var action = {};

  action.preload = () => {
    const current_id = page.slider.items.eq(action.slickCurrent()).data('car');
    page.settings.lastID++;
    if (page.settings.lastID > page.settings.queue.length - 1) page.settings.lastID = 0;
    const id = page.settings.queue[page.settings.lastID];
    $.ajax({
      url: '/ajax/dc/slider/used/',
      method: 'POST',
      type: 'JSON',
      data: {
        id: id,
        current_id: current_id,
      },
      success: data => action.handle(data),
    });
  };

  action.handle = data => {
    if (data.status === 'error') action.handleError(data.message);
    else action.handleSuccess(data);
  };

  action.handleError = message => {
    Popup.message(message, 'error');
  };

  action.handleSuccess = data => {
    const idToRemove = page.slider.items.eq(0).data('car'),
      totalToRemove = page.slider.items.filter(function (index) {
        return page.slider.items.eq(index).data('car') === idToRemove;
      }).length,
      currentSlide = action.slickCurrent() - totalToRemove;

    for (var i = totalToRemove; i > 0; i--) page.slider.container.slick('slickRemove', i - 1);

    page.slider.container.slick('slickGoTo', currentSlide, true);

    page.slider.container.slick('slickAdd', data.html);
    page.specs.html(data.specs);
    page.gallery.html(data.gallery);
    page.slider.items = $('.dc-slider__item');
  };

  action.initSlider = () => {
    page.slider.container.slick(page.settings.slider);
  };

  action.startTicking = () => {
    page.settings.startTime = new Date();
  };

  action.getState = (currentSlide, nextSlide) => {
    return page.slider.items.eq(currentSlide).data('car') !== page.slider.items.eq(nextSlide).data('car');
  };

  action.getCurrentSlide = () => {
    return page.slider.items.eq(action.slickCurrent);
  };

  action.slickCurrent = () => {
    return page.slider.container.slick('slickCurrentSlide');
  };

  action.getEvents = () => {
    var needToPreload = false;
    page.slider.container.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      needToPreload = action.getState(currentSlide, nextSlide);
      page.slider.container.slick('slickSetOption', 'autoplaySpeed', getSpeed(nextSlide));
    });

    page.slider.container.on('afterChange', function (event, slick, currentSlide) {
      if (action.slickCurrent() === 0) return;

      if (needToPreload) {
        needToPreload = false;
        action.preload();
      }
    });
  };

  action.start = () => {
    page.settings.lastID = page.settings.queue.indexOf(page.slider.items.last().data('car').toString());
    action.initSlider();
    action.startTicking();
    action.getEvents();
  };

  if (page.slider.container.length) action.start();
});
